import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Space } from 'antd';
import React from 'react';

const FooterBtns = (props) => {
    const { onSaveCustomization, onAddNewCard, onCancel, customData } = props;

    const items = [
        {
          label: 'Preferences',
          key: 'menu_customization_preferences'
        },
        {
          label: 'Add-ons',
          key: 'menu_customization_addons'
        }];
    const menuProps = {
        items,
        onClick: onAddNewCard,
    };
    return <div className="footer_btns">
    {/* <Button danger onClick={ onAddNewCard }>Add New Customization +</Button> */}
    <Dropdown menu={menuProps}>
      <Button danger>
        <Space>
        Add New Customization
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
    <Button type="primary save_btn" danger disabled={!customData.name} onClick={()=>{ onSaveCustomization(); }}> Save</Button>
    <Button danger onClick={ onCancel }>Cancel</Button>

    </div>
};
export default FooterBtns;
